<template>
  <div class="" id="owner_dashboard">
    <SidePageColumn side="right">
      <div class="text-left">
        <template v-for="(menu_item, index) in sub_menu_items">
          <NavbarMenuItem
            v-if="can_access(menu_item)"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></NavbarMenuItem>
        </template>
      </div>
      <v-divider
        class="mt-4"
        v-if="attrs.right_quick_links.length > 0"
      ></v-divider>
      <QuickSideLinks
        :quick_links="attrs.right_quick_links"
        v-if="attrs.right_quick_links.length > 0"
      ></QuickSideLinks>
    </SidePageColumn>
    <CenterNavbar
      :crumps="attrs.crumps"
      :title="attrs.title"
      :width_class="page_info.center_width_class"
      :show_staff="true"
      :navbar_cols="attrs.navbar_cols ? attrs.navbar_cols : 4"
    ></CenterNavbar>
    <div class="inner-page-container">
      <div class="d-flex justify-space-around white pt-5">
        <DasboardBoxWidget
          :is_loading="is_loading"
          color="warning"
          :num_text="comma(dashboard.num_businesses)"
          sub_text="registered"
          main_text="businesses"
          link="/owner/businesses/list"
          icon="mdi-home-city-outline"
        ></DasboardBoxWidget>
        <DasboardBoxWidget
          :is_loading="is_loading"
          color="success"
          :num_text="comma(dashboard.num_promotions)"
          sub_text="created"
          main_text="promotions"
          link="/owner/promotions/list"
          icon="mdi-tv"
        ></DasboardBoxWidget>
        <DasboardBoxWidget
          :is_loading="is_loading"
          color="info"
          :num_text="comma(dashboard.num_contact_businesses_messages)"
          sub_text="contact"
          main_text="messages"
          link="/owner/contact_us_messages/list"
          icon="mdi-email-variant"
        ></DasboardBoxWidget>
        <DasboardBoxWidget
          :is_loading="is_loading"
          color="error"
          :num_text="comma(dashboard.num_notifications)"
          sub_text="received"
          main_text="notifications"
          link="/owner/notifications/list"
          icon="mdi-bell"
        ></DasboardBoxWidget>
      </div>
      <v-row no-gutters class="white pt-5">
        <v-col cols="8 pl-8 pb-10">
          <div class="grey lighten-5 round-4 elevation-4">
            <div class="pt-1 pb-1">Trend Of Business Views (past 30 days)</div>
            <v-divider></v-divider>
            <SparklineGraph
              :value="dashboard.business_views_graph_value"
              :labels="dashboard.business_views_graph_labels"
              type="trend"
              :height="160"
              :label_size="5"
            >
            </SparklineGraph>
            <v-divider></v-divider>
            <v-btn
              block
              small
              text
              :disabled="is_loading"
              color="primary"
              class="mt-0"
              :to="'/owner/reports/views'"
            >
              Go To View Report
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="4" class="pl-2 pr-8 pb-10">
          <div class="grey lighten-3 round-4 elevation-4">
            <div class="pt-1 pb-1">Lastest Messages</div>
            <v-divider></v-divider>
            <div
              class="mhgt-widget text-left pr-2 pl-2"
              v-if="dashboard.latest_messages.length > 0"
            >
              <div
                v-for="(msg, index) in dashboard.latest_messages"
                :key="index"
                class="d-flex justify-space-between mt-3 bb-1-dotted"
              >
                <div
                  class="d-inline-block text-truncate"
                  style="max-width: 150px; font-size: 14px"
                >
                  {{ msg.message }}
                </div>
                <div class="d-inline-block pr-2">
                  <small>{{ msg.sent_date }}</small>
                </div>
              </div>
            </div>
            <div
              class="mhgt-widget text-left pr-2 pl-2"
              v-if="dashboard.latest_messages.length == 0"
            >
              //nyd Sad Emoji No messages in inbox
            </div>
            <v-divider></v-divider>
            <v-btn
              block
              small
              text
              :disabled="is_loading"
              color="primary"
              class="mt-0"
              :to="'/owner/contact_us_messages/list'"
            >
              View Inbox
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import SidePageColumn from "./../../components/SidePageColumn";
import SparklineGraph from "./../../components/SparklineGraph";
import QuickSideLinks from "./../../components/QuickSideLinks";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
import NavbarMenuItem from "./../../components/NavbarMenuItem";
import CenterNavbar from "./../../components/CenterNavbar";
import DasboardBoxWidget from "./../../components/DasboardBoxWidget";

import page_info from "./../../lib/page_info";
export default {
  name: "OwnerDashboard",
  components: {
    SidePageColumn,
    NavbarMenuItem,
    CenterNavbar,
    QuickSideLinks,
    DasboardBoxWidget,
    SparklineGraph,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      _user: null,
      sub_menu_items: [],
      page_info: page_info,
      attrs: Utils.get_default_page_attr(),
      dashboard: {
        num_businesses:  0,
        num_promotions: 0,
        num_contact_businesses_messages: 0,
        num_notifications: 0,
        business_views_graph_value: [], //[1, 2, 34, 5, 6, 6, 7, 88, 8, 8, 9],
        business_views_graph_labels: [], //[1, 2, 34, 5, 6, 6, 7, 88, 8, 8, 9],
        latest_messages: [],
      },
    };
  },
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    comma(v){
      if(v < 10){
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    load_items() {
      var today_date = new Date();
      var month_ago_date = today_date.addDays(-30);

      var start_time_str =
        Utils.get_today_date_str(month_ago_date) + " 00:30:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);

      var end_time_str = Utils.get_today_date_str(today_date) + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);

      this.$emit("on-show-loader");
      ServerClient.Dashboards.get_owners_dashboard(
        {
          id: this._user.id,
          start_time_stamp: start_time,
          end_time_stamp: end_time,
        },
        (res) => {
          var temp_db = res;
          //process views
          var plot_items = Utils.process_promo_graph_data(
            Utils.get_today_date_str(month_ago_date),
            Utils.get_today_date_str(today_date),
            temp_db.business_views_graph_value,
            false
          );
          temp_db.business_views_graph_value = plot_items.values;
          temp_db.business_views_graph_labels = plot_items.labels;

          this.dashboard = temp_db;
          this.$emit("on-hide-loader");
        },
        (errors) => {
          console.log("Errors while loading business dashboard ", errors);
          this.$emit("on-hide-loader");
        }
      );
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();

    this.attrs = {
      title: "My DashBoard",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Dashboard",
          disabled: true,
          href: "/owner/dashboard",
        },
      ],
      right_quick_links: [],
    };

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_dashboard", options);
    this.load_items();
  },
};
</script>